import './base';
import Splide from '@splidejs/splide';
import {
  initSlider
} from './src/photo-slider';
import SmartPhoto from 'smartphoto';
import {
  path
} from './src/const';
import {
  scrollById
} from './src/utils';
import {
  createTabs
} from './src/tabs';

import {
  updateBasketFromProduct,
  updateBasketFromList
} from './src/action';
import {
  loadLazyProducts
} from './src/lazy-products';
// import './src/joomshopping';
import {
  deliveryData
} from './src/product-delivery';
import {
  ProductAction
} from './src/product-action';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

new ProductAction();
createTabs();
deliveryData.init();

const productSlider = new Splide('.photo-product__slider', {
  rewind: false,
  perPage: 1,
  arrows: true,
  arrowPath: path,
  classes: {
    arrows: 'splide__arrows photo-product__arrows',
    arrow: 'splide__arrow photo-product__arrow',
    prev: 'splide__arrow--prev photo-product__arrow--prev',
    next: 'splide__arrow--next photo-product__arrow--next',
  },
  pagination: false,
  mediaQuery: 'min',
  breakpoints: {
    '992': {
      perPage: 2,
    }
  }
});

const thumbnailsSlider = new Splide('.thumbnails', {
  type: 'slide',
  perMove: 1,
  fixedHeight: 107,
  fixedWidth: 80,
  isNavigation: true,
  gap: '12px',
  perPage: 6,
  arrowPath: path,
  classes: {
    arrows: 'splide__arrows thumbnails__arrows',
    arrow: 'splide__arrow thumbnails__arrow',
    prev: 'splide__arrow--prev thumbnails__arrow--prev',
    next: 'splide__arrow--next thumbnails__arrow--next',
  },
  pagination: false,
  cover: true,
  breakpoints: {
    '1649': {
      gap: '10px',
      perPage: 5,

    },
    '991': {
      destroy: true
    }
  }
});


productSlider.sync(thumbnailsSlider);
productSlider.mount();
thumbnailsSlider.mount();

const isEnough = thumbnailsSlider.Components.Slides.isEnough();

if (isEnough) {
  thumbnailsSlider.root.classList.add('thumbnails--swipe');
}


const searchProduct = document.querySelector('.search-product__splide');

if (searchProduct) {
  new Splide('.search-product__splide', {
    arrowPath: path,
    autoWidth: true,
    pagination: false,
    arrows: false,
    mediaQuery: 'min',
    destroy: true,
    classes: {
      arrows: 'splide__arrows search-product__arrows',
      arrow: 'splide__arrow search-product__arrow',
      prev: 'splide__arrow--prev search-product__arrow--prev',
      next: 'splide__arrow--next search-product__arrow--next',
    },
    breakpoints: {
      '768': {
        arrows: true,
        destroy: false,
        drag: false,
      },
    },
  }).mount();
}

loadLazyProducts();

initSlider();
updateBasketFromProduct();

new SmartPhoto('.js-smartphoto', {
  forceInterval: 1
});

// Показать все характеристики

const clipContainer = document.querySelector('.js-clip');

if (clipContainer) {
  const btn = clipContainer.querySelector('.js-clip-btn');
  btn.addEventListener('click', function () {
    clipContainer.classList.remove('js-clip');
    btn.remove();
  });
}

// Скролл к доставке

const linkToDelivery = document.querySelector('.stock__info');
const deliveryTab = document.querySelector('.tab__button[data-id="delivery"]');

if (linkToDelivery && deliveryTab) {
  linkToDelivery.addEventListener('click', function (evt) {
    evt.preventDefault();
    scrollById('#productTab', 30);
    deliveryTab.click();
  });
}

tippy('.help-product__status', {
  content: 'Работаем ежедневно с 6:00 до 15:00 по Москве'
});

tippy(document.querySelectorAll('.variants__link'), {
  content(reference) {
    return reference.querySelector('.variants__title').textContent;
  },
  touch: false,
});


const wbLink = document.querySelector('.wb-box__link');

if (wbLink) {
  wbLink.addEventListener('click', function (evt) {
    const target = evt.currentTarget;
    const digits = target.href.match(/\d+/)[0];

    if (digits) {
      fetch(`/index.php?option=com_jshopping&controller=product&task=hitWB&nmId=${digits}`)
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
        })
        .catch(error => console.error('Ошибка:', error));
    }
  });
}
